import * as React from "react";
import { forwardRef } from "react";
const SvgInfoIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M16 16H9.06264V11.6928C9.06264 11.1201 8.5917 10.6488 8.00604 10.6488C7.42038 10.6488 6.94943 11.1201 6.94943 11.6928V16H0V5.9657L8 0L16 5.9657V16ZM10.5721 14.5086H14.4906V6.71141L8 1.86726L1.50943 6.71141V14.5086H5.44V11.6928C5.44 10.2968 6.59321 9.15735 8.00604 9.15735C9.41887 9.15735 10.5721 10.2968 10.5721 11.6928V14.5086Z", fill: "#666E8D" }));
const ForwardRef = forwardRef(SvgInfoIcon);
export default ForwardRef;
